import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import './formatter.scss';

export default function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  const isPrefixRequired = { ...props.id };
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix={(props.id == 'EUR') ? '€' : (props.id == 'GBP') ? '£' : (props.id == 'USD') ? '$' : ''}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  prefixRequired: PropTypes.bool.isRequired
};
